module.exports = __webpack_public_path__ + "img/instagramestory7.89d6bb62.jpg";